export class DomUtils {
  // MAP-990: node/link styles were split into "light"/"advanced" sub-components
  // (behind a more/less button); they're now a single, always-mounted
  // component per entity whose core-style groups collapse their own
  // dependents, so a single selector per entity replaces the former
  // light+advanced pair.
  static selectors = {
    nodeStyleSection: {
      selector: 'maporium-node-style',
      children: ':scope > *'
    },
    linkStyleSection: {
      selector: 'maporium-link-style',
      children: ':scope > *'
    }
  };

  static getElementCount(selectorKey: keyof typeof DomUtils.selectors): number {
    const container = document.querySelector(DomUtils.selectors[selectorKey].selector);
    if (!container) {
      return 0;
    }

    const elements = Array.from(container.querySelectorAll(DomUtils.selectors[selectorKey].children))
      .filter(el => (el as HTMLElement).offsetHeight > 0); // ✅ Only count elements with height > 0
    return elements.length;
  }

  static isElementEmpty(selectorKey: keyof typeof DomUtils.selectors): boolean {
    return DomUtils.getElementCount(selectorKey) === 0;
  }
}
